module.exports = __webpack_public_path__ + "media/img/pages/profile/bund ger 9-7c9fdb51f6b14644f47feae4b8221443.jpg";